<template>
  <b-modal ref="filterWindow" title="Voyage Traveler Filter Window" :visible="value" @change="$emit('input', $event)" size="lg" scrollable>
    <div class="voyage-traveler-filter-window">
      <div class="row mb-3">
        <div class="col">
          <b-button-group class="float-right" size="sm">
            <b-button @click="openAllFilters()" variant="outline-primary">Expand all</b-button>
            <b-button @click="hideAllFilters()" variant="outline-danger">Collapse all</b-button>
          </b-button-group>
        </div>
      </div>

      <b-form id="voyage-traveler-filter-form" @submit.stop.prevent="runSearch()">
        <section class="filter-personal-info filter-section">
          <div class="row">
            <div class="col">
              <button type="button" class="btn-collapse-trigger btn btn-light" @click="toggleCollapse('isPersonalInfoCollapseOpen')">
                <div class="text-center text-lg-left font-weight-bold">Personal Information</div>
                <div class="collapse-icon text-right" :class="{ active: uiControls.isPersonalInfoCollapseOpen }"></div>
              </button>
            </div>
          </div>

          <b-collapse id="personal-info-collapse" class="filter-collapse" :visible="uiControls.isPersonalInfoCollapseOpen">
            <div class="filter-collapse-content">
              <div class="row align-items-center">
                <b-form-group class="col-12 col-md-6" label="Traveler type" label-for="input-traveler-type" label-size="sm">
                  <b-form-select id="input-traveler-type" placeholder="Select traveler type" v-model="form.type" :options="formOptions.travelerTypes" size="sm"> </b-form-select>
                </b-form-group>
              </div>

              <div class="row align-items-center">
                <b-form-group class="col-12 col-md" label="First name" label-for="input-first-name" label-size="sm">
                  <b-form-input id="input-first-name" type="text" placeholder="e.g. Adam" v-model="form.fNm" size="sm"></b-form-input>
                </b-form-group>

                <b-form-group class="col-12 col-md" label="Last name" label-for="input-last-name" label-size="sm">
                  <b-form-input id="input-last-name" type="text" placeholder="e.g. Taylor" v-model="form.lNm" size="sm"></b-form-input>
                </b-form-group>
              </div>

              <div class="row align-items-center">
                <b-form-group class="col-12 col-md" label="Other name(s)" label-for="input-middle-name" label-size="sm">
                  <b-form-input id="input-middle-name" type="text" placeholder="e.g. Gregory Thomas..." v-model="form.mNm" size="sm"></b-form-input>
                </b-form-group>
              </div>

              <div class="row align-items-center">
                <b-form-group class="col-12 col-md" label="Gender" label-for="input-gender" label-size="sm" v-slot="{ ariaDescribedby }">
                  <b-radio-group
                    id="input-gender"
                    :options="formOptions.genders"
                    v-model="form.gn"
                    :aria-describedby="ariaDescribedby"
                    name="radio-options"
                    size="sm"
                  ></b-radio-group>
                </b-form-group>
              </div>

              <div class="row align-items-start">
                <div class="col-12"><span class="filter-date-label">Date of birth</span></div>
                <template v-if="!formControls.dob.range">
                  <b-form-group class="col-12 col-md" label="Date" label-for="input-dob" label-class="filter-date-sub-label">
                    <b-form-datepicker id="input-dob" v-model="form.dob.eq" :max="new Date()" size="sm" reset-button></b-form-datepicker>
                  </b-form-group>
                </template>
                <template v-else>
                  <b-form-group class="col-12 col-md" label="Start date" label-for="input-dob-start-date" label-class="filter-date-sub-label">
                    <b-form-datepicker id="input-dob-start-date" v-model="form.dob.gte" :max="dobMaxDate" size="sm" reset-button></b-form-datepicker>
                  </b-form-group>
                  <b-form-group class="col-12 col-md" label="End date" label-for="input-dob-end-date" label-class="filter-date-sub-label">
                    <b-form-datepicker id="input-dob-end-date" v-model="form.dob.lte" :min="dobMinDate" :max="new Date()" size="sm" reset-button></b-form-datepicker>
                  </b-form-group>
                </template>

                <b-form-group class="col-12 col-md-2" label="Toggle range" label-for="input-toggle-range-dob" label-class="filter-date-sub-label">
                  <b-form-checkbox
                    id="input-toggle-range-dob"
                    class="d-flex justify-content-lg-center"
                    v-model="formControls.dob.range"
                    @input="toggleRange('dob')"
                    switch
                  ></b-form-checkbox>
                </b-form-group>
              </div>

              <div class="row align-items-center">
                <b-form-group class="col-12 col-lg" label="Nationality" label-for="input-nationality" label-size="sm">
                  <b-form-select id="input-nationality" placeholder="Select nationality" v-model="form.nal" size="sm">
                    <b-form-select-option :value="null">None selected</b-form-select-option>
                    <b-form-select-option v-for="country of countries" :key="country.CODE2" :value="country.CODE2">
                      {{ `${country.COUNTRYNAME} (${country.CODE3})` }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group class="col-12 col-lg" label="Country of birth" label-for="input-place-birth" label-size="sm">
                  <b-form-select id="input-place-birth" placeholder="Select country" v-model="form.pob" size="sm">
                    <b-form-select-option :value="null">None selected</b-form-select-option>
                    <b-form-select-option v-for="country of countries" :key="country.CODE2" :value="country.CODE2">
                      {{ `${country.COUNTRYNAME} (${country.CODE3})` }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group class="col-12 col-lg" label="Country of residence" label-for="input-country-residence" label-size="sm">
                  <b-form-select id="input-country-residence" placeholder="Select country" v-model="form.ctryRes" size="sm">
                    <b-form-select-option :value="null">None selected</b-form-select-option>
                    <b-form-select-option v-for="country of countries" :key="country.CODE2" :value="country.CODE2">
                      {{ `${country.COUNTRYNAME} (${country.CODE3})` }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>
            </div>
          </b-collapse>
        </section>

        <section class="filter-documents filter-section">
          <div class="row">
            <div class="col">
              <button type="button" class="btn-collapse-trigger btn btn-light" @click="toggleCollapse('isDocumentsCollapseOpen')">
                <div class="text-center text-lg-left font-weight-bold">Travel Documents</div>
                <div class="collapse-icon text-right" :class="{ active: uiControls.isDocumentsCollapseOpen }"></div>
              </button>
            </div>
          </div>

          <b-collapse id="documents-collapse" class="filter-collapse" :visible="uiControls.isDocumentsCollapseOpen">
            <div class="filter-collapse-content">
              <div class="row align-items-center">
                <b-form-group class="col-12 col-md" label="Document type" label-for="input-doc-type" label-size="sm">
                  <b-form-select id="input-doc-type" placeholder="Select document type" v-model="form.docType" :options="formOptions.docTypes" size="sm"> </b-form-select>
                </b-form-group>

                <b-form-group class="col-12 col-md" label="Document number" label-for="input-doc-num" label-size="sm">
                  <b-form-input id="input-doc-num" type="text" placeholder="e.g. 1291847" v-model="form.docN" size="sm"></b-form-input>
                </b-form-group>
              </div>

              <div class="row align-items-center">
                <b-form-group class="col-12 col-lg-6" label="Document country" label-for="input-doc-country" label-size="sm">
                  <b-form-select id="input-doc-country" placeholder="Select country" v-model="form.docCtry" size="sm">
                    <b-form-select-option :value="null">None selected</b-form-select-option>
                    <b-form-select-option v-for="country of countries" :key="country.CODE2" :value="country.CODE2">
                      {{ `${country.COUNTRYNAME} (${country.CODE3})` }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>

              <div class="row align-items-start">
                <div class="col-12"><span class="filter-date-label">Document expiry</span></div>
                <template v-if="!formControls.docExp.range">
                  <b-form-group class="col-12 col-md" label="Date" label-for="input-doc-exp" label-class="filter-date-sub-label">
                    <b-form-datepicker id="input-doc-exp" v-model="form.docExp.eq" size="sm" reset-button></b-form-datepicker>
                  </b-form-group>
                </template>
                <template v-else>
                  <b-form-group class="col-12 col-md" label="Start date" label-for="input-doc-exp-start-date" label-class="filter-date-sub-label">
                    <b-form-datepicker id="input-doc-exp-start-date" v-model="form.docExp.gte" :max="docExpMaxDate" size="sm" reset-button></b-form-datepicker>
                  </b-form-group>
                  <b-form-group class="col-12 col-md" label="End date" label-for="input-doc-exp-end-date" label-class="filter-date-sub-label">
                    <b-form-datepicker id="input-doc-exp-end-date" v-model="form.docExp.lte" :min="docExpMinDate" size="sm" reset-button></b-form-datepicker>
                  </b-form-group>
                </template>

                <b-form-group class="col-12 col-md-2" label="Toggle range" label-for="input-toggle-range-doc-exp" label-class="filter-date-sub-label">
                  <b-form-checkbox
                    id="input-toggle-range-doc-exp"
                    class="d-flex justify-content-lg-center"
                    v-model="formControls.docExp.range"
                    @input="toggleRange('docExp')"
                    switch
                  ></b-form-checkbox>
                </b-form-group>
              </div>
            </div>
          </b-collapse>
        </section>

        <section class="filter-address filter-section">
          <div class="row">
            <div class="col">
              <button type="button" class="btn-collapse-trigger btn btn-light" @click="toggleCollapse('isDestinationCollapseOpen')">
                <div class="text-center text-lg-left font-weight-bold">Destination Address</div>
                <div class="collapse-icon text-right" :class="{ active: uiControls.isDestinationCollapseOpen }"></div>
              </button>
            </div>
          </div>

          <b-collapse id="address-collapse" class="filter-collapse" :visible="uiControls.isDestinationCollapseOpen">
            <div class="filter-collapse-content">
              <div class="row align-items-center">
                <b-form-group class="col-12 col-md-6" label="Country" label-for="input-destination-country" label-size="sm">
                  <b-form-select id="input-destination-country" placeholder="Select country" v-model="form.destCtry" size="sm">
                    <b-form-select-option :value="null">None selected</b-form-select-option>
                    <b-form-select-option v-for="country of countries" :key="country.CODE2" :value="country.CODE2">
                      {{ `${country.COUNTRYNAME} (${country.CODE3})` }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>

                <b-form-group v-if="showStates" class="col-12 col-md" label="State" label-for="input-destination-state" label-size="sm">
                  <b-form-select id="input-destination-state" placeholder="Select state" v-model="form.destState" size="sm">
                    <b-form-select-option :value="null">None selected</b-form-select-option>
                    <b-form-select-option v-for="(state, index) of formOptions.states" :key="`state-${index}`" :value="state.english ? state.english : state.name">
                      {{ state.english ? state.english : state.name }}
                    </b-form-select-option>
                  </b-form-select>
                </b-form-group>
              </div>

              <div class="row align-items-center">
                <b-form-group class="col-12 col-md-6" label="City" label-for="input-destination-city" label-size="sm">
                  <b-form-input id="input-destination-city" type="text" placeholder="e.g. London" v-model="form.destCity" size="sm"></b-form-input>
                </b-form-group>

                <b-form-group class="col-12 col-md" label="Zip code" label-for="input-destination-zip" label-size="sm">
                  <b-form-input id="input-destination-zip" type="text" placeholder="e.g. HB1763" v-model="form.destZip" size="sm"></b-form-input>
                </b-form-group>
              </div>

              <div class="row align-items-center">
                <b-form-group class="col-12 col-md" label="Street address" label-for="input-destination-street" label-size="sm">
                  <b-form-input id="input-destination-street" type="text" placeholder="e.g. #18 Mountain View" v-model="form.destStr" size="sm"></b-form-input>
                </b-form-group>
              </div>
            </div>
          </b-collapse>
        </section>
      </b-form>
    </div>

    <template #modal-footer>
      <button type="reset" class="btn btn-outline-secondary float-right" form="voyage-traveler-filter-form" @click="resetFilters()">Reset</button>
      <button type="submit" class="btn btn-primary ml-2 float-right" form="voyage-traveler-filter-form">Search</button>
    </template>
  </b-modal>
</template>

<script>
import FilterMixin from '../../mixins/filter.mixin';
import _ from '../../utils/lodash.util';
import stateList from '../../_data/provinces_states.json';

export default {
  name: 'FilterVoyageTravelers',

  mixins: [FilterMixin],

  data() {
    // Get query params from route
    const routeQueries = this.$router.currentRoute.query;

    // Populate form with query params
    let form = {
      // Personal info
      type: routeQueries['type'] || null,
      fNm: routeQueries['fNm'] || null,
      lNm: routeQueries['lNm'] || null,
      mNm: routeQueries['mNm'] || null,
      gn: routeQueries['gn'] || null,
      dob: routeQueries['dob'] ? { gte: routeQueries['dob'].gte, lte: routeQueries['dob'].lte, eq: routeQueries['dob'].eq } : { gte: null, lte: null, eq: null },
      nal: routeQueries['nal'] || null,
      pob: routeQueries['pob'] || null,
      ctryRes: routeQueries['ctryRes'] || null,

      // Documents
      docType: routeQueries['docType'] || null,
      docN: routeQueries['docN'] || null,
      docCtry: routeQueries['docCtry'] || null,
      docExp: routeQueries['docExp'] ? { gte: routeQueries['docExp'].gte, lte: routeQueries['docExp'].lte, eq: routeQueries['docExp'].eq } : { gte: null, lte: null, eq: null },

      // Address
      destStr: routeQueries['destStr'] || null,
      destCity: routeQueries['destCity'] || null,
      destState: routeQueries['destState'] || null,
      destCtry: routeQueries['destCtry'] || null,
      destZip: routeQueries['destZip'] || null
    };

    // Form controls
    let formControls = {
      // Set inital range controls based on if range fields (gte or lte) set.
      dob: { range: Boolean(form.dob.gte || form.dob.lte) },
      docExp: { range: Boolean(form.docExp.gte || form.docExp.lte) }
    };

    let formOptions = {
      travelerTypes: [
        { value: null, text: 'None selected' },
        { value: 'C', text: 'Crew Member' },
        { value: 'P', text: 'Passenger' }
        // { value: 'TC', text: 'Transit Crew Member' },
        // { value: 'TP', text: 'Transit Passenger' }
      ],
      genders: [
        { value: null, text: 'None selected' },
        { value: 'M', text: 'Male' },
        { value: 'F', text: 'Female' },
        { value: 'O', text: 'Other' },
        { value: 'U', text: 'Unknown' }
      ],
      docTypes: [
        { value: null, text: 'None selected' },
        { value: 'P', text: 'Passport' },
        { value: 'V', text: 'Visa' }
      ],
      states: []
    };

    // Check if initial form values for each section are empty
    const personalInfoFormFields = _.removeEmptyValues(_.pick(form, ['type', 'fNm', 'lNm', 'mNm', 'gn', 'dob', 'nal', 'pob', 'ctryRes']));
    const documentsFormFields = _.removeEmptyValues(_.pick(form, ['docType', 'docN', 'docCtry', 'docExp']));
    const destinationFormFields = _.removeEmptyValues(_.pick(form, ['destStr', 'destCity', 'destState', 'destCtry', 'destZip']));

    // UI controls
    let uiControls = {
      // If one or more fields in section are not empty, open collapse initially
      isPersonalInfoCollapseOpen: !_.isEmpty(personalInfoFormFields),
      isDocumentsCollapseOpen: !_.isEmpty(documentsFormFields),
      isDestinationCollapseOpen: !_.isEmpty(destinationFormFields)
    };

    // Send initial filters to parent
    this.$emit('filtersSetup', _.removeEmptyValues(form));

    return { form, formControls, uiControls, formOptions, stateList };
  },

  computed: {
    dobMinDate() {
      return this.$moment(this.form.dob.gte).format('YYYY-MM-DD');
    },

    dobMaxDate() {
      const endDate = this.$moment(this.form.dob.lte);
      return endDate.isValid() ? endDate.format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD');
    },

    docExpMinDate() {
      return this.$moment(this.form.docExp.gte).format('YYYY-MM-DD');
    },

    docExpMaxDate() {
      return this.$moment(this.form.docExp.lte).format('YYYY-MM-DD');
    },

    selectedDestinationCountry() {
      return this.form.destCtry;
    },

    showStates() {
      return this.formOptions.states.length !== 0;
    }
  },

  methods: {
    toggleRange(filterName) {
      if (this.formControls[filterName].range === true) {
        this.form[filterName].eq = null;
      } else {
        this.form[filterName].gte = null;
        this.form[filterName].lte = null;
      }
    },

    resetFilters() {
      this.form = {
        type: null,
        fNm: null,
        lNm: null,
        mNm: null,
        gn: null,
        dob: { gte: null, lte: null, eq: null },
        nal: null,
        pob: null,
        ctryRes: null,
        docType: null,
        docN: null,
        docCtry: null,
        docExp: { gte: null, lte: null, eq: null },
        destStr: null,
        destCity: null,
        destState: null,
        destCtry: null,
        destZip: null
      };

      this.formControls = {
        dob: { range: false },
        docExp: { range: false }
      };
    }
  },

  watch: {
    selectedDestinationCountry() {
      const states = this.stateList.filter((state) => state.country === this.selectedDestinationCountry);
      if (states.length > 0) {
        // Sort states by name
        states.sort((a, b) => {
          let nameA = (a.english ? a.english : a.name).toLowerCase();
          let nameB = (b.english ? b.english : b.name).toLowerCase();

          if (nameA < nameB) return -1;
          if (nameA > nameB) return 1;
          return 0;
        });
      }

      this.formOptions.states = states;
    }
  }
};
</script>

<style lang="scss" src="../../assets/styles/filter.scss" scoped></style>
